module.exports = __webpack_public_path__ + "static/media/Silver_fern_flag.017f4ed0.svg";